export function encodePublicKey(publicKey) {
    return {
        suite: publicKey.suite,
        key: bytesToBase64(publicKey.key),
    };
}
export function decodePublicKey(publicKey) {
    return {
        suite: publicKey.suite,
        key: base64ToBytes(publicKey.key),
    };
}
export function encodeIdentitySecret(identity) {
    return {
        publicKey: encodePublicKey(identity.publicKey),
        secretKey: bytesToBase64(identity.secretKey),
    };
}
export function decodeIdentitySecret(keyId, secret) {
    return {
        keyId,
        publicKey: decodePublicKey(secret.publicKey),
        secretKey: base64ToBytes(secret.secretKey),
    };
}
export function bytesToBase64(bytes) {
    let binary = '';
    for (let i = 0; i < bytes.length; i++)
        binary += String.fromCharCode(bytes[i]);
    return btoa(binary);
}
export function base64ToBytes(value) {
    const binary = atob(value);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++)
        bytes[i] = binary.charCodeAt(i);
    return bytes;
}
